const PAYMENT_PLAN_STATUSES = {
    pending_approval: 'Pendiente',
    approved: 'Activo',
    paid: 'Pagado',
    cancelled: 'Cancelado',
    rejected: 'Rechazado'
};
export default PAYMENT_PLAN_STATUSES;
